import { FilterFactory } from "angular";
import { tokenizeString } from "./masking-util";

/**
 * A filter that masks the input string to a specific format and
 * hides characters indicated by the mask with asterisks.
 */
export const MaskFilter: FilterFactory = () => {
    'ngInject';
    return (text: string, mask: string) => {
        const tokens = tokenizeString(text, mask || "");
        return tokens.map(c => {
            if (c.token === "secret") {
                return "●";
            }
            if (c.token === "separator"){
                return "-";
            }
            return c.value;
        }).join("");
    };
}
